<template>
  <div class="c-student">
    <div class="c-student__head">
      <i class="head-icon" />
      <p class="head-title">学生掌握明细</p>
      <div class="head-operate">
        <el-input v-model="searchName" clearable placeholder="请输入学生名称">
        </el-input>
        <el-button type="primary" @click="onSearchClick">查询</el-button>
      </div>
    </div>

    <section class="c-student__table">
      <el-table
        ref="multipleTable"
        :header-cell-style="{ background: '#F0F2F5', color: '#909399' }"
        :data="studentData"
        style="width: 100%"
      >
        <div slot="empty" class="no-data">
          <emptyContent />
        </div>
        <el-table-column type="index" width="50" label="序号" align="center">
        </el-table-column>
        <el-table-column
          v-for="item in tableName"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :sortable="item.sortable"
          align="center"
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'avg_ability'">
              <span :class="getRightClass(scope.row[item.prop])">
                {{
                  scope.row[item.prop] === 0 ? "--" : scope.row[item.prop] + "%"
                }}
              </span>
            </template>
            <template v-else-if="item.prop === 'avg_right_rate'">
              <span :class="getRightClass(scope.row[item.prop])">
                {{ scope.row[item.prop] + "%" }}
              </span>
            </template>
            <template v-else-if="item.prop === 'cost_time'">
              <span>
                {{
                  scope.row[item.prop] === 0
                    ? "--"
                    : secondToDate(scope.row[item.prop])
                }}
              </span>
            </template>
            <template v-else-if="item.prop === 'right_rate'">
              <span>
                {{
                  scope.row[item.prop] === 0 ? "--" : scope.row[item.prop] + "%"
                }}
              </span>
            </template>
            <template v-else-if="item.prop === 'low_score_count'">
              <span>
                {{
                  scope.row[item.prop] === 0
                    ? "--"
                    : scope.row[item.prop] + "个"
                }}
              </span>
            </template>
            <template v-else-if="item.prop === 'submit_time'">
              <span>
                {{
                  scope.row[item.prop] === 0 ? "未提交" : scope.row[item.prop]
                }}
              </span>
            </template>
            <template slot-scope="scope" v-else>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="queryStudentReport(scope.$index, scope.row)"
            >
              <div :class="scope.row.status === 1 ? '' : 'disable-color'">
                {{fromTypeText}}
              </div>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
  </div>
</template>

<script>
import { getStuScoreList } from '@/api/pt';
import emptyContent from '../../components/empty-content.vue';
import { openTab, isScienceArr } from '@/utils';

export default {
  name: 'StudentDetail',
  components: {
    emptyContent,
  },
  props: {
    studentData: {
      type: Array,
      default: () => [],
    },
    changeData: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    tableName() {
      return Number(this.fromType) === 3 ? this.mtColumnName : this.columnName;
    },
  },
  data() {
    const { fromType, evaluateId } = this.$route.query;
    return {
      stuTotalList: [],
      fromType,
      searchName: '',
      columnName: [{
        label: '学生名称',
        prop: 'account_name',
        sortable: false,
      }, {
        label: '掌握程度',
        prop: 'avg_ability',
        sortable: true,
      }, {
        label: '正答率',
        prop: 'avg_right_rate',
        sortable: true,
      }, {
        label: '练习用时',
        prop: 'cost_time',
      }, {
        label: '未掌握知识点数',
        prop: 'low_score_count',
        sortable: true,
      }, {
        label: '提交时间',
        prop: 'submit_time',
      }],
      mtColumnName: [{
        label: '学生名称',
        prop: 'account_name',
        sortable: false,
      }, {
        label: '正答率',
        prop: 'avg_right_rate',
        sortable: true,
      }, {
        label: '练习用时',
        prop: 'cost_time',
      }, {
        label: '提交时间',
        prop: 'submit_time',
      }],
      studentList: [],
      timer: null,
      changeColumn: {},
      fromTypeText: Number(fromType) === 3 ? '查看详情' : '查看报告',
      evaluateId,
    };
  },
  watch: {
    // changeData(v) {
    //   this.changeColumn = v;
    // },
    // studentData(v) {
    //   this.studentList = v;
    // },
    // spreadData(v) {
    //   if (v.length) {
    //     this.$nextTick(() => {
    //       this.$refs.singleTable.setCurrentRow(v[0]);
    //       this.stuTotalList = v[0].stu_list;
    //     });
    //   }
    // },
  },
  methods: {
    // 时分秒转化
    secondToDate(result) {
      const seconds = result % 60;
      const minutes = Math.floor(result / 60);
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
    onSearchClick() {
      // change后的值处理
      if (Object.keys(this.changeData).length) {
        this.getStuScoreList(this.searchName, this.changeData);
      }
      // return;
      this.getStuScoreList(this.searchName, {});
    },
    // 正答率样式添加
    getRightClass(value) {
      if (value === -1) {
        return 'default';
      }
      if (value >= 70) {
        return 'level2';
      }
      if (value >= 40) {
        return 'level1';
      }
      return 'level3';
    },
    queryStudentReport(index, item) {
      const { fromType } = this.$route.query;
      let path = '';
      if (Number(fromType) === 3) {
        path = isScienceArr(this.$route.query.subjectId) ? '/mt-web/transition' : '/artsSelf/transition'; // 文理科
      } else if (Number(fromType) === 4) {
        path = '/amt-web/task';
      }
      const isProduction = !window.location.host.includes('dev');
      // 区分线上和测试环境
      const address = isProduction
        ? 'http://jzjx.classba.cn'
        : 'http://jzjx.test.classba.cn'; // 测试环境
      if (item.status === 1) {
        const url = `${address}${path}?userId=${item.user_id}&courseId=${item.course_id}&topicId=${item.topic_id}&sectionId=${item.section_id}&subjectId=${item.subject_id}&basename=${item.base_name}&sModule=0&noCache=0&hwId=${this.changeData.evaluate_id || this.evaluateId}&realname=${item.account_name}`;
        console.log('url----------------', url);
        openTab(url);
      }
    },
    getStuScoreList(value, data) {
      const { evaluateId, schoolId, classId } = this.$route.query;
      return getStuScoreList({
        evaluate_id: data.evaluate_id
          ? data.evaluate_id
          : evaluateId,
        school_id: schoolId,
        class_id: data.class_id
          ? data.class_id
          : classId,
        name: value,
      }).then((res) => {
        if (res.code === 200) {
          this.studentList = res.data || [];
          this.$emit('change-data', this.studentList);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-student {
  box-sizing: border-box;
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  &__spread {
    display: flex;
    padding: 20px;
    .spread-left {
      width: 28%;
    }
    .spread-right {
      width: 72%;
      height: 286px;
      border: 1px solid #f0f2f5;
      background: #f5f7fa;
      &__header {
        height: 47px;
        text-align: center;
        line-height: 47px;
        background: #f0f2f5;
        color: rgb(144, 147, 153);
        font-weight: 600;
        font-size: 14px;
        font-family: Arial, Helvetica, sans-serif;
      }
      &__content {
        font-size: 14px;
        height: 239px;
        color: #606266;
        overflow: auto;
        font-family: Arial, Helvetica, sans-serif;
        clear: both;
        .content-item {
          width: 20%;
          height: 47px;
          line-height: 47px;
          text-align: center;
          float: left;
        }
      }
    }
  }
  &__head {
    padding-left: 19px;
    position: relative;
    .head-icon {
      display: block;
      background: url("~@/views/pt/images/class_bg.png");
      background-size: cover;
      width: 38px;
      height: 29px;
    }
    .head-title {
      position: absolute;
      top: 5px;
      left: 34px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
    .head-operate {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 25px;
      .el-button {
        border-radius: 0 4px 4px 0;
      }
      .el-input {
        width: 243px;
        vertical-align: bottom;
        /deep/ .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
    }
  }
  &__table {
    padding: 0 20px;
    .disable-color {
      color: #909399;
    }
  }
}

/deep/ .el-table__body tr.current-row > td {
  background-color: #f5f7fa;
}

.no-data {
  line-height: 1.8;
  padding: 30px 0;
}

.student-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 16px;
  img {
    width: 200px;
    margin-top: 35px;
  }
  .empty-text {
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
